import axios from 'axios';

const setAuthToken = (token) => {
    axios.defaults.baseURL = "https://oicodebootcamp.herokuapp.com/api/v1";
  if (token) {
    axios.defaults.headers.common = {'Authorization': `Bearer ${token}`};
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export default setAuthToken;